import React, { useState, useEffect } from "react";
import OcjeneDataTable from "../components/OcjeneDataTable";
import OcjeneGroupedDataTable from "../components/OcjeneGroupedDataTable";
import UnauthorizedAccess from "../components/UnauthorizedAccess";
import InternalServerError from "../components/InternalServerError";

export const Ocjene = (props) => {
  const [restData, setRestData] = useState(null);
  const [fetchState, setFetchState] = useState(null);

  useEffect(() => {
    console.log(" >>>>>>> props.rest: " + props.rest);
    fetch(
      props.rest +
        sessionStorage.getItem("ustanova") +
        "&prema_obliku=" +
        sessionStorage.getItem("premaObliku") +
        "&godina_upisa=" +
        sessionStorage.getItem("godinaUpisa") +
        "&redni_broj=" +
        sessionStorage.getItem("redniBroj") +
        "&razred=" +
        sessionStorage.getItem("razredPregleda"),
      {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then((response) => {
        //console.log("Response ocjene: " + response);
        if (response.status === 200) {
          setFetchState(200);
          return response.json();
        } else if (response.status === 204) {
          setFetchState(204);
          return null;
        } else if (response.status === 401) {
          setFetchState(401);
          return null;
        } else if (response.status === 500) {
          setFetchState(500);
          return null;
        } else {
          return null;
        }
      })
      .then((data) => {
        //console.log("Data stringify test:" + JSON.stringify(data));
        setRestData(data);
      })
      .catch((err) => {
        //console.log("Error ocjene:" + err);
      });
  }, [props.rest]);

  return (
    <div>
      <div>
        {fetchState === 200 ? (
          <><p className="page-title">Pregled svih ocjena za {sessionStorage.getItem("razredPregleda")}. razred</p>
            <OcjeneDataTable data={restData} />{" "}
            <p className="page-title">Pregled ocjena po predmetu za {sessionStorage.getItem("razredPregleda")}. razred</p>
            <OcjeneGroupedDataTable data={restData} />
          </>
        ) : (
          ""
        )}
        {fetchState === 401 ? <UnauthorizedAccess /> : ""}
        {fetchState === 500 ? <InternalServerError /> : ""}
      </div>
    </div>
  );
};

export default Ocjene;
